import { useCallback, useState } from 'react';
import { useMutation } from '@apollo/client';
import { UPDATE_COMPANY } from '@general/graphql/company.graph';

const useCompanyUpdate = ({ ...options } = {}) => {
    const { onCompleted, onError, ...otherOptions } = options;
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isSuccessful, setIsSuccessful] = useState(false);
    const [error, setError] = useState();

    const [updateCompanyMutation] = useMutation(UPDATE_COMPANY, {
        onCompleted: () => {
            setIsSubmitting(false);
            setIsSuccessful(true);
            setError();

            setTimeout(() => {
                setIsSuccessful(false);
            }, 3000);

            if (onCompleted) {
                onCompleted();
            }
        },

        onError: error => {
            setIsSubmitting(false);
            setIsSuccessful(false);
            setError(error);

            setTimeout(() => {
                setError();
            }, 3000);

            if (onError) {
                onError(error);
            }
        },
        ...otherOptions,
    });

    const updateCompany = useCallback(
        async ({ variables }) => {
            setIsSubmitting(true);

            await updateCompanyMutation({
                variables,
            });
        },
        [updateCompanyMutation]
    );

    return { updateCompany, isSubmitting, isSuccessful, error };
};

export default useCompanyUpdate;
